export default "__VITE_ASSET__BCdfPEVM__"